import { ChildrenProps } from '../types/ChildrenProps';

export const Banner = ({ children }: ChildrenProps) => {
  if (!children) {
    return null;
  }
  return (
    <div
      className='open-day-banner px-4 py-3 md:relative z-10 text-white'
      style={{ backgroundColor: '#00adea', fontFamily: 'Arial, sans-serif' }}
    >
      <style>{`.open-day-banner, .open-day-banner * { font-family: Arial, sans-serif !important; }`}</style>
      <div className='flex items-center justify-between gap-4'>
        <div className='h-14 md:h-16 flex-shrink-0 basis-[50%] max-w-[50%] overflow-hidden'>
          <img
            src='https://www.macs.vic.edu.au/MelbourneArchdioceseCatholicSchools/media/News-Events/Other/OpenDays_FMCS2.png'
            alt='Open Days'
            className='h-full w-auto block'
            style={{
              transform: 'translateX(-2%) scaleX(1.45)',
              transformOrigin: 'center',
            }}
          />
        </div>
        <div className='basis-[50%] max-w-[50%] text-left leading-tight'>
          {children}
        </div>
      </div>
    </div>
  );
};
